var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataDrivenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 99,
    viewBox: "0 0 98 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 49.5938,
    r: 49,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.0013,
    cy: 49.5941,
    r: 40.8333,
    fill: "#F3B330"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7362 49.584H23.3398C23.3333 63.561 34.8144 74.8975 48.9859 74.9087V62.6824C41.6608 62.6712 35.7313 56.8086 35.7378 49.584H35.7362Z",
    fill: "#0D5C9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0059 24.2803V36.4969C45.8807 36.4937 42.8549 37.5779 40.461 39.5583L35.1992 28.2459C39.321 25.6455 44.1138 24.269 49.0059 24.2819V24.2803Z",
    fill: "#0D5C9C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4189 39.205L55.8551 49.5841L49.0039 43.357V24.2803C59.1057 24.2803 68.2694 30.1204 72.4189 39.205Z",
    fill: "#0D5C9C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6581 49.584C74.676 63.553 63.2079 74.8911 49.0446 74.9088C49.0381 74.9088 49.03 74.9088 49.0234 74.9088V43.3151L55.8747 49.5423L72.4384 39.1631C73.922 42.4413 74.6776 45.9942 74.6581 49.584Z",
    fill: "#42A2DA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4606 39.5586C37.4575 42.0498 35.7264 45.7247 35.7362 49.5957H23.3398C23.3398 40.9496 27.815 32.901 35.2102 28.2559L40.4606 39.5586Z",
    fill: "url(#paint0_linear_1595_1458)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4606 39.5586C37.4575 42.0498 35.7264 45.7247 35.7362 49.5957H23.3398C23.3398 40.9496 27.815 32.901 35.2102 28.2559L40.4606 39.5586Z",
    fill: "#42A2DA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7542 52.7498L51.7188 59.0653L59.1823 64.1923L70.8442 50.9541L59.5959 58.1739L55.7542 52.7498Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4639 37.8158C53.419 37.8158 54.1934 37.0521 54.1934 36.1101C54.1934 35.168 53.419 34.4043 52.4639 34.4043C51.5087 34.4043 50.7344 35.168 50.7344 36.1101C50.7344 37.0521 51.5087 37.8158 52.4639 37.8158Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1748 37.8158C59.13 37.8158 59.9043 37.0521 59.9043 36.1101C59.9043 35.168 59.13 34.4043 58.1748 34.4043C57.2196 34.4043 56.4453 35.168 56.4453 36.1101C56.4453 37.0521 57.2196 37.8158 58.1748 37.8158Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8857 37.8158C64.8409 37.8158 65.6152 37.0521 65.6152 36.1101C65.6152 35.168 64.8409 34.4043 63.8857 34.4043C62.9306 34.4043 62.1562 35.168 62.1562 36.1101C62.1562 37.0521 62.9306 37.8158 63.8857 37.8158Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1595_1458",
    x1: 23.3398,
    y1: 38.9242,
    x2: 40.4606,
    y2: 38.9242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D35400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataDrivenIcon);
export default __webpack_public_path__ + "static/media/DataDrivenIcon.68e27229525977ba14ac810e22a17f74.svg";
export { ForwardRef as ReactComponent };